import { Box } from '@mui/material'
import { useApplicationAppRights, useTargetPerson } from 'hooks'
import { FC, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@mui/material'
import { ProtectedApplicationAssignmentInfo } from '../AssignmentTile'
import { useResourceTypeContext } from 'resourceTypeContext'

const take = 3

export type ApplicationAppRightsProps = {
    applicationId: string
    applicationsType: any
    applicationTypeRegistry: any
    setShowSpacer: any
}

export const ApplicationAppRights: FC<ApplicationAppRightsProps> = (
    props: ApplicationAppRightsProps,
) => {
    const [page, setPage] = useState(1)
    const appRightRef = useRef<HTMLDivElement>(null)

    const scrollToDiv = () => {
        if (appRightRef.current) {
            appRightRef?.current?.scrollIntoView({ behavior: 'smooth' })
        }
    }
    const {
        applicationId,
        applicationsType,
        applicationTypeRegistry,
        setShowSpacer,
    } = props
    const { t } = useTranslation()
    const [targetPerson] = useTargetPerson()
    const [{ selectedAppRoleOrRightToHighLight }, dispatch]: any =
        useResourceTypeContext()
    const { data, isInitialLoading } = useApplicationAppRights(
        applicationId,
        targetPerson.id,
        (page - 1) * take,
        take,
    )

    const pageCount = data?.totalCount ? Math.ceil(data.totalCount / take) : 0

    useEffect(() => {
        if (data?.data?.length) {
            setShowSpacer(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (data?.data?.length && selectedAppRoleOrRightToHighLight) {
            const isSelectedExist = data.data.find(
                (x: any) =>
                    x?.localRightId &&
                    x.localRightId === selectedAppRoleOrRightToHighLight,
            )
            if (isSelectedExist) {
                dispatch({
                    type: 'UPDATE_SELECTED_ACCESS_LEVEL_ALREADY_ASSIGNED',
                    payload: {
                        selectedAppRoleOrRightAlreadyAssigned: true,
                        accessType: 'localRightId',
                    },
                })
                // scroll to selection
                scrollToDiv()
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAppRoleOrRightToHighLight])

    const bindAppRight = () => {
        try {
            if (data?.data?.length) {
                return data.data.map((item: any) => {
                    return {
                        resource: {
                            ...item,
                            description:
                                item?.description || item.assignmentPointName,
                            requestPolicyId: item.accessRequestPolicyId,
                            id: item?.localRightId,
                            manageAccessId: item?.id, //NOTE: Adding this as per API change and not to break the generic function logic in FE
                        },
                        assignment: {
                            personId: targetPerson.id,
                            isAssigned: item.isAssigned,
                            canActivateNow: item.canActivateNow,
                            isRenewable: item.isRenewable,
                            assignmentId: item?.id,
                            resourceAssignment: {
                                id: item.applicationId,
                                friendlyName: item.assignmentPointName,
                                resourceAssignmentId: item?.localRightId,
                            },
                            assignmentDetails: {
                                isRevokable: item.isRevocable,
                                timeConstraintActive: item.timeConstraintActive,
                                startDateUtc: item.startDateUtc,
                                endDateUtc: item.endDateUtc,
                            },
                        },
                    }
                })
            }
        } catch (err) {}
        return []
    }

    return (
        <Box>
            {isInitialLoading ? (
                <Skeleton height={40} />
            ) : data?.data?.length ? (
                <Box ref={appRightRef}>
                    <ProtectedApplicationAssignmentInfo
                        totalCount={data?.totalCount}
                        setPage={(value: any) => setPage(value)}
                        pageCount={pageCount}
                        resourceAssignment={bindAppRight() || []}
                        title={t('Common_AppRights')}
                        resourceType={applicationsType}
                        manageAccessRedirectTab="appRights"
                        applicationId={applicationId}
                        applicationTypeRegistry={applicationTypeRegistry}
                        mappingKeyForType="localRightId"
                        page={page}
                    />
                </Box>
            ) : null}
        </Box>
    )
}
